import { render, staticRenderFns } from "./overviewBoxListItem.vue?vue&type=template&id=191eaf3e&"
import script from "./overviewBoxListItem.vue?vue&type=script&lang=js&"
export * from "./overviewBoxListItem.vue?vue&type=script&lang=js&"
import style0 from "./overviewBoxListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports